export enum InvitationPasswordActionType {
  CONFIRM_INVITATION_PASSWORD = 'INVITATION_PASSWORD/CONFIRM_INVITATION_PASSWORD',
  CONFIRM_INVITATION_PASSWORD_SUCCESS = 'INVITATION_PASSWORD/CONFIRM_INVITATION_PASSWORD_SUCCESS',
  CONFIRM_INVITATION_PASSWORD_ERROR = 'INVITATION_PASSWORD/CONFIRM_INVITATION_PASSWORD_ERROR',
}

export const confirmInvitationPassword = (password: string, token: string) => ({
  type: InvitationPasswordActionType.CONFIRM_INVITATION_PASSWORD,
  password,
  token,
});

export const confirmInvitationPasswordSuccess = () => ({
  type: InvitationPasswordActionType.CONFIRM_INVITATION_PASSWORD_SUCCESS,
});

import { ErrorInfo } from '../../utils/error-codes';

export const confirmInvitationPasswordError = (error: ErrorInfo) => ({
  type: InvitationPasswordActionType.CONFIRM_INVITATION_PASSWORD_ERROR,
  error,
});
